// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0d319efe","455":"12831ccb","977":"ab9cc940"}[chunkId] + ".chunk.js";
};